import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ReactGA from "react-ga";

import ReactCSSTransitionReplace from "react-css-transition-replace";

import * as actions from "actions";

import { CompanySearch, Ripples } from "components";

import HelpBlockTab3B from "components/help-block-tab3b";
import HelpBlockTab4B from "components/help-block-tab4b";

import Tab0 from "./tab0/tab0";
import Tab0B from "./tab0b/tab0b";
import Tab1 from "./tab1/tab1";
import Tab1Turnover from "./tab1-turnover/tab1-turnover";

import SingleInvoiceFile from "./single-invoice/file";
import SingleInvoiceCompany from "./single-invoice/company";
import SingleInvoiceCheck from "./single-invoice/check";
import SingleInvoicePrice from "./single-invoice/price";
import SingleInvoiceRedirect from "./single-invoice/redirecting";

import Tab1DrawnDown from "./tab1-draw-down/tab1-drawn-down";
import Tab2 from "./tab2/tab2";
import Tab3A from "./tab3/tab3a";
import Tab3B from "./tab3/tab3b";
import Tab4A from "./tab4/tab4a";
import Tab4B from "./tab4/tab4b";
import Tab5A from "./tab5/tab5a";
import Tab5B from "./tab5/tab5b";
import Tab6 from "./tab6/tab6";
import Tab7 from "./tab7/tab7";

const FormSection = styled.div.attrs({
  className: ""
})`
  @import url(https://fonts.googleapis.com/css?family=${props => props.font.replace(" ", "+")}:300, 400, 600, 700);
  font-family: ${props => props.font};
`;

class App extends Component {
  componentDidMount = () => {
    this.props.getSubdomainInfo();
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.domainInfoLoaded && !prevProps.domainInfoLoaded) {
      const options = {
        debug: process.env.NODE_ENV !== "production",
        testMode: process.env.NODE_ENV !== "production"
      }
      if(this.props.domain.Country === "us") {
        //init GA tracking
        ReactGA.initialize("UA-118270835-2", options);
      }
        else if(this.props.domain.Country === "nl")
      {
        ReactGA.initialize("UA-118270835-4", options);
      } else {
        //init GA tracking
        ReactGA.initialize("UA-118270835-1", options);
      }
      const sessionId = new URLSearchParams(this.props.location.search).get("session");

      const gclid = new URLSearchParams(this.props.location.search).get("gclid");
      const forceSingleInvoice = new URLSearchParams(this.props.location.search).get("singleInvoice");
      const singleInvoiceEnabled = new URLSearchParams(this.props.location.search).get("testSingleInvoiceEnabled");
      const singleInvoiceThreshold = new URLSearchParams(this.props.location.search).get("testSingleInvoiceThreshold");

      if (gclid !== null) {
        var date = new Date();
        date.setTime(date.getTime() + 90 * 24 * 60 * 60 * 1000);
        document.cookie = "gclid=" + gclid + ";expires=" + date.toGMTString();
      }

      if (sessionId !== null) {
        this.props.getSession(sessionId);
      } else {
        this.props.createSession(forceSingleInvoice, singleInvoiceEnabled, singleInvoiceThreshold);
      }
    }
  };
  render() {
    const activeTab = new URLSearchParams(this.props.location.search).get("activeTab");
    if (!this.props.retrievalDone) {
      return (
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <Ripples />
        </div>
      );
    }

    const _props = {
      tab: activeTab,
      key: activeTab
    };

    let content = null;
    switch (activeTab) {
      //key is added to the tabs for the css transitions
      case "tab0":
        content = <Tab0 {..._props} />;
        break;
      case "tab0b":
        content = <Tab0B {..._props} />;
        break;
      case "tab1":
        content = <Tab1 {..._props} />;
        break;
      case "turnover":
        content = <Tab1Turnover {..._props} />;
        break;
      case "single-invoice-file":
        content = <SingleInvoiceFile {..._props} />;
        break;
      case "single-invoice-company":
        content = <SingleInvoiceCompany {..._props} />;
        break;
      case "single-invoice-check":
        content = <SingleInvoiceCheck {..._props} />;
        break;
      case "single-invoice-price":
        content = <SingleInvoicePrice {..._props} />;
        break;
      case "single-invoice-redirect":
        content = <SingleInvoiceRedirect {..._props} />;
        break;
      case "drawn-down":
        content = <Tab1DrawnDown {..._props} />;
        break;
      case "tab2":
        content = <Tab2 {..._props} />;
        break;
      case "tab3a":
        content = <Tab3A {..._props} />;
        break;
      case "tab3b":
        content = <Tab3B {..._props} />;
        break;
      case "tab4a":
        content = <Tab4A {..._props} />;
        break;
      case "tab4b":
        content = <Tab4B {..._props} />;
        break;
      case "tab5a":
        content = <Tab5A {..._props} />;
        break;
      case "tab5b":
        content = <Tab5B {..._props} />;
        break;
      case "tab6":
        content = <Tab6 {..._props} />;
        break;
      case "tab7":
        content = <Tab7 {..._props} />;
        break;
      default:
        content = <Tab0 {..._props} />;
        break;
    }

    return (
      <FormSection font={this.props.domain.Font}>
        <div className="form_section">
          <div className="form_container">
            <CompanySearch />
            <HelpBlockTab3B />
            <HelpBlockTab4B />

            <ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
              {content}
            </ReactCSSTransitionReplace>
          </div>
        </div>
      </FormSection>
    );
  }
}
/*
<div style={{ position: "absolute" }}>
              {tabOrder.map(tab => (
                <Link key={tab} to={`/quote?activeTab=${tab}&session=${this.props.sessionId}`}>
                  {tab}
                  <br />
                </Link>
              ))}
            </div>
            */

const mapStateToProps = state => {
  return { ...state.app };
};
const mapDispatchToProps = dispatch => {
  return {
    getSubdomainInfo: () => dispatch({ type: actions.GET_SUBDOMAIN_INFO }),

    getSession: sessionId => dispatch({ type: actions.GET_SESSION, sessionId }),
    createSession: (forceSingleInvoice, singleInvoiceEnabled, singleInvoiceThreshold) => dispatch({ type: actions.CREATE_SESSION, forceSingleInvoice, singleInvoiceEnabled, singleInvoiceThreshold })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
